var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1012_4013)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42 0H6C2.69 0 0 2.69 0 6V42C0 45.308 2.69 48 6 48H42C45.308 48 48 45.308 48 42V6C48 2.69 45.308 0 42 0Z",
    fill: "#3B5999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33 24V18C33 16.344 34.344 16.5 36 16.5H39V9H33C30.6131 9 28.3239 9.94821 26.636 11.636C24.9482 13.3239 24 15.6131 24 18V24H18V31.5H24V48H33V31.5H37.5L40.5 24H33Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1012_4013"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.d44dc0db64b80a8e86b3d9a0a076bb37.svg";
export { ForwardRef as ReactComponent };